export function invoiceToday() {
  const parts = Object.fromEntries(new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Zurich", year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(new Date()).map(part => [part.type, part.value]))
  return parts.year + "-" + parts.month + "-" + parts.day
}
export function invoiceDueDate() {
  const date = new Date(invoiceToday() + "T00:00:00Z")
  date.setUTCDate(date.getUTCDate() + 30)
  return date.toISOString().slice(0, 10)
}
export function validInvoiceDate(value) {
  if (typeof value !== "string" || !/^20\d\d-\d\d-\d\d$/.test(value)) return false
  const date = new Date(value + "T00:00:00Z")
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value
}
export async function downloadInvoicePdf(blob, filename, isCurrent = () => true) {
  if (!blob || !blob.size || typeof blob.slice !== "function" || await blob.slice(0, 5).text() !== "%PDF-") throw new Error("Es wurde kein gültiges Rechnungs-PDF geliefert.")
  if (!isCurrent()) return
  const url = URL.createObjectURL(blob), link = document.createElement("a")
  link.href = url; link.download = filename.replace(/[^a-zA-Z0-9_.-]/g, "-")
  try { document.body.appendChild(link); link.click() }
  finally { link.remove(); window.setTimeout(() => URL.revokeObjectURL(url), 1000) }
}
